import React from 'react';

import { defineMessage, useIntl } from 'react-intl';

import { cssMap } from '@atlaskit/css';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives
import Inline from '@atlaskit/primitives/inline';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives
import Stack from '@atlaskit/primitives/stack';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives
import Text from '@atlaskit/primitives/text';
import { token } from '@atlaskit/tokens';

export type FieldCardProps = {
	fieldIcon?: React.ReactNode;
	fieldName: string;
	fieldOptions?: string[];
	fieldType?: string;
};

const fieldTypeLabel = defineMessage({
	id: 'ai-mate-jira-admin-agent.jira-admin-agent.FieldCard.fieldTypeLabel.non-final',
	defaultMessage: 'Field type',
	description: 'Label of the field type section',
});

const fieldNameLabel = defineMessage({
	id: 'ai-mate-jira-admin-agent.jira-admin-agent.FieldCard.fieldNameLabel.non-final',
	defaultMessage: 'Field name',
	description: 'Label of the field name section',
});

const fieldOptionsLabel = defineMessage({
	id: 'ai-mate-jira-admin-agent.jira-admin-agent.FieldCard.fieldOptionsLabel.non-final',
	defaultMessage: 'Options',
	description: 'Label of the field options section',
});

const styles = cssMap({
	fieldWrapper: {
		paddingTop: token('space.150'),
		paddingBottom: token('space.150'),
	},
});

export const FieldCard = ({
	fieldIcon,
	fieldName,
	fieldOptions,
	fieldType,
}: FieldCardProps): React.JSX.Element => {
	const { formatMessage } = useIntl();
	return (
		<>
			{fieldType && (
				<Stack xcss={styles.fieldWrapper}>
					<Text color="color.text.subtlest">{formatMessage(fieldTypeLabel)}</Text>
					<Inline space="space.100">
						{fieldIcon}
						<Text>{fieldType}</Text>
					</Inline>
				</Stack>
			)}
			<Stack xcss={styles.fieldWrapper}>
				<Text color="color.text.subtlest">{formatMessage(fieldNameLabel)}</Text>
				<Text>{fieldName}</Text>
			</Stack>
			{fieldOptions && (
				<Stack xcss={styles.fieldWrapper}>
					<Text color="color.text.subtlest">{formatMessage(fieldOptionsLabel)}</Text>
					<ul>
						{fieldOptions.map((option) => (
							<li key={option}>{option}</li>
						))}
					</ul>
				</Stack>
			)}
		</>
	);
};
